import { v4 as uuid } from 'uuid';
import { isEmpty } from "lodash";

import { getApiErrorByCode } from './ApiErrors';
import { getoOauthErrorByKey } from './OauthErrors';

export async function dispatch (error) {
    console.log('\n\n\n errorsStore.dispatch() -> ', error);
    if (!isEmpty(error) && error?.code) {
        this.error = getApiErrorByCode(error.code);
        this.error.code = error.code;
        this.observed.error = uuid();
    }

    if (!isEmpty(error) && error?.oauthErrorKey) {
        let key = error?.oauthErrorKey;
        if (error.oauthErrorKey === 'OAUTH_FAILED') {
            key = `${error.selectedCalendar.toUpperCase()}_OAUTH_FAILED`;
        }
        this.error = getoOauthErrorByKey(key);
        this.observed.error = uuid();
    }

    if (!isEmpty(error) && error.title && error.message) {
        this.error = { ...error };
        this.observed.error = uuid();
    }

    try {
        // to ensure that this fix won't broke anything.
        if (!isEmpty(this.error)) {
            clearTimeout(this.dispatchTo);
            const appStore = this.env.appStore;
            const errStore = this;
            this.dispatchTo = setTimeout(() => {
                appStore.trackAndLog({
                    endpoint: `${errStore.endpoint}`,
                    traceString: `traceString::sync-display.v2.error-${this.error?.title}-${this.error?.message}`,
                });
            }, 1000);
        }
    } catch (err) {

    }
  
}

export default dispatch;
